module.exports = __webpack_public_path__ + "img/emoji_72.c6e08132.png";